import { branch, compose, renderComponent, withHandlers } from 'recompose';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import { getActiveShopCountry, getUserUrlPrefix } from '../../auth/selectors';
import withPermissions from '../../auth/utils/withPermissions';
import { canUserModifyBankAccounts, canUserViewBankAccounts } from '../helpers/users';
import NoPermissionsInfoModal from './NoPermissionsInfoModal';
import { COUNTRY_NAME_BY_CODE } from '../../main/shops/constants';
import { fetchStripeLink } from './actions';
import withOwnerTypeAndId from '../hoc/withOwnerTypeAndId';
import openLinkInNewWindow from '../helpers/openLinkInNewWindow';
import { flagNames, withInjectFeatureFlagsToProps } from '../../../modules/infra/feature-flags';
import { STRIPE_ONBOARDING_RETURN_SEARCH_PARAM } from '../../../modules/shared/onboarding';

export default compose(
  withRouter,
  withPermissions,
  withOwnerTypeAndId,
  withInjectFeatureFlagsToProps([flagNames.STRIPE_HOSTED_ONBOARDING]),
  connect((state, ownProps) => ({
    canUserSetupPaymentInfo:
      canUserViewBankAccounts(ownProps.permissions) && canUserModifyBankAccounts(ownProps.permissions),
    urlPrefix: getUserUrlPrefix(state),
    isUSBased: getActiveShopCountry(state) === COUNTRY_NAME_BY_CODE.US,
  })),
  withHandlers({
    goToStripeHostedOnboarding: props => async () => {
      // eslint-disable-next-line max-len
      const returnUrl = `${window.location.origin}${props.urlPrefix}/settings/payment-processing?${STRIPE_ONBOARDING_RETURN_SEARCH_PARAM}=true`;
      const stripeLink = await fetchStripeLink(props.ownerType, props.ownerId, returnUrl);
      if (stripeLink) {
        openLinkInNewWindow(stripeLink);
      }
    },
    goToPaymentProcessingUrl: props => (url) => {
      if (props.canUserSetupPaymentInfo) {
        props.router.push(url);
      } else if (props.restrictFullPage) {
        props.router.push('/');
      }
    },
  }),
  withHandlers({
    goToOnboardingUrl: props => (url) => {
      if (props[flagNames.STRIPE_HOSTED_ONBOARDING]) {
        props.goToStripeHostedOnboarding();
      } else {
        props.goToPaymentProcessingUrl(url);
      }
    },
  }),
  withHandlers({
    onSetupPaymentInfoHandler: props => () => {
      props.onClose();
      props.goToOnboardingUrl(`${props.urlPrefix}/settings/payment-processing/add/personal`);
    },
    onCloseHandler: props => () => {
      props.onClose();
      props.goToPaymentProcessingUrl(`${props.urlPrefix}/settings/payment-processing`);
    },
  }),
  branch(
    props => !props.canUserSetupPaymentInfo,
    renderComponent(NoPermissionsInfoModal),
  ),
);
